var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkInBadge = function SvgCheckmarkInBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#10A2FC",
    clipPath: "url(#clip-path-checkmark-in-badge)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.37 33.39-.25-.15c-4.41-2.6-7.59-5.09-9.72-7.61a7.6 7.6 0 0 1-1.75-4.9V6.21l5.76-1.59a22.26 22.26 0 0 1 11.9 0l5.76 1.59v14.52a7.6 7.6 0 0 1-1.75 4.9c-2.13 2.52-5.31 5.01-9.71 7.61l-.25.15h.01ZM8.65 6.97v13.76c0 1.59.54 3.1 1.51 4.25 2.01 2.39 5.03 4.76 9.21 7.24 4.18-2.49 7.19-4.86 9.21-7.24a6.6 6.6 0 0 0 1.51-4.25V6.97l-5.03-1.39a21.3 21.3 0 0 0-11.37 0L8.66 6.97h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.37 36.45-.25-.15c-4.75-2.8-8.32-5.48-10.91-8.19a11.83 11.83 0 0 1-3.2-8.23V3.99l8.58-2.23a22.4 22.4 0 0 1 11.55 0l8.59 2.23v15.87c0 3.15-1.14 6.07-3.2 8.23-2.59 2.71-6.16 5.39-10.91 8.19l-.25.15v.02ZM6 4.77v15.1c0 2.89 1.04 5.57 2.92 7.54 2.48 2.6 5.9 5.18 10.44 7.87 4.54-2.7 7.96-5.27 10.44-7.87a10.8 10.8 0 0 0 2.92-7.54V4.77l-7.84-2.04a21.3 21.3 0 0 0-11.04 0L6 4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.37 22.27a5.78 5.78 0 1 1 .02-11.56 5.78 5.78 0 0 1-.02 11.56Zm0-10.53a4.78 4.78 0 1 0 .01 9.55 4.78 4.78 0 0 0-.01-9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.69 18.64-1.87-1.88.71-.7 1.16 1.16 2.52-2.51.7.71-3.22 3.22Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-checkmark-in-badge"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 1h28.73v35.45H5z"
  })))));
};
export default SvgCheckmarkInBadge;